// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-width: 0;
  color: var(--ca-text-primary, #172033);
}

.breadcrumb {
  margin-top: 1.5rem;
  margin-left: 1.5rem;
}

.breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 1.25rem;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.875rem;
}

.breadcrumb-link {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  color: var(--ca-primary, #0e2e80);
  font-weight: 500;
}

.breadcrumb-link i,
.breadcrumb-current i {
  font-size: 1.15rem;
}

.breadcrumb-separator {
  color: var(--ca-text-muted, #8c96a8);
}

.breadcrumb-current {
  color: var(--ca-text-secondary, #4b5870);
  font-weight: 600;
}

.asset-mapping-page {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  padding: 1.5rem;
  margin: 0 auto;
}

.page-header,
.list-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1.25rem;
  margin-bottom: 1.25rem;
}

.page-heading {
  min-width: 0;
}

.page-heading h1 {
  margin: 0 0 0.35rem;
  color: var(--ca-text-primary, #172033);
  font-size: clamp(1.35rem, 2vw, 1.7rem);
  font-weight: 650;
  letter-spacing: -0.02em;
  line-height: 1.3;
}

.page-heading p,
.list-heading p {
  margin: 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.9rem;
  line-height: 1.55;
}

.page-header-meta {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.75rem;
  min-width: 9.5rem;
  padding: 0.7rem 0.9rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
}

.header-meta-icon {
  display: grid;
  width: 2.4rem;
  height: 2.4rem;
  flex: 0 0 2.4rem;
  place-items: center;
  border-radius: var(--ca-radius-sm, 6px);
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 1.1rem;
}

.page-header-meta > div {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.page-header-meta strong {
  color: var(--ca-text-primary, #172033);
  font-size: 1.1rem;
  line-height: 1.2;
}

.page-header-meta span:not(.header-meta-icon) {
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.72rem;
  white-space: nowrap;
}

.asset-list-card {
  min-width: 0;
  padding: 1.25rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
}

.list-heading {
  align-items: center;
}

.section-eyebrow {
  margin-bottom: 0.35rem;
  color: var(--ca-primary-light, #2850ad);
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.1em;
}

.list-heading h2 {
  margin: 0 0 0.3rem;
  color: var(--ca-text-primary, #172033);
  font-size: 1.15rem;
  font-weight: 700;
}

.mapping-legend {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.6rem;
}

.legend-item {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 0.65rem;
  border: 1px solid transparent;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 650;
  white-space: nowrap;
}

.legend-dot {
  width: 0.45rem;
  height: 0.45rem;
  border-radius: 50%;
}

.legend-mapped {
  border-color: var(--ca-success-border, #b7e3ca);
  background: var(--ca-success-bg, #eaf7f0);
  color: var(--ca-success, #198754);
}
.legend-mapped .legend-dot {
  background: var(--ca-success, #198754);
}

.legend-unmapped {
  border-color: #f3b9c0;
  background: var(--ca-danger-bg, #fdecef);
  color: var(--ca-danger, #dc3545);
}
.legend-unmapped .legend-dot {
  background: var(--ca-danger, #dc3545);
}

.search-toolbar {
  display: grid;
  grid-template-columns: minmax(16rem, 1.5fr) minmax(13rem, 0.85fr) auto;
  gap: 0.875rem;
  margin-bottom: 1.25rem;
}

.search-field {
  display: flex;
  min-width: 0;
  align-items: stretch;
}

.search-control {
  width: 100%;
  min-width: 0;
  min-height: 2.65rem;
  border: 1px solid var(--ca-input-border, #dfe4ec);
  border-radius: var(--ca-radius-md, 8px);
  background-color: var(--ca-input-bg, #fff);
  color: var(--ca-text-primary, #172033);
  font-size: 0.9rem;
}
.search-control:focus {
  border-color: var(--ca-input-focus, #2850ad);
  box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.15);
  outline: 0;
}
.search-control::placeholder {
  color: var(--ca-text-muted, #8c96a8);
}

.search-field .search-control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.search-submit {
  display: inline-grid;
  width: 2.8rem;
  flex: 0 0 2.8rem;
  place-items: center;
  border: 1px solid var(--ca-primary, #0e2e80);
  border-radius: 0 var(--ca-radius-md, 8px) var(--ca-radius-md, 8px) 0;
  background: var(--ca-primary, #0e2e80);
  color: #fff;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.search-submit:hover {
  background: var(--ca-primary-dark, #0d2863);
}
.search-submit:focus-visible {
  position: relative;
  z-index: 1;
  outline: 3px solid rgba(40, 80, 173, 0.25);
  outline-offset: 2px;
}

.btn-primary,
.btn-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-height: 2.6rem;
  padding: 0.65rem 1rem;
  border-radius: var(--ca-radius-md, 8px);
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.25;
  white-space: nowrap;
  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}
.btn-primary:focus-visible,
.btn-secondary:focus-visible {
  outline: 3px solid rgba(40, 80, 173, 0.25);
  outline-offset: 2px;
  box-shadow: none;
}
.btn-primary:disabled,
.btn-secondary:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.btn-primary {
  border: 1px solid var(--ca-primary, #0e2e80);
  background: var(--ca-primary, #0e2e80);
  color: #fff;
}
.btn-primary:hover:not(:disabled) {
  border-color: var(--ca-primary-dark, #0d2863);
  background: var(--ca-primary-dark, #0d2863);
  color: #fff;
}

.btn-secondary {
  border: 1px solid var(--ca-border, #dfe4ec);
  background: var(--ca-surface, #fff);
  color: var(--ca-primary, #0e2e80);
}
.btn-secondary:hover:not(:disabled) {
  border-color: var(--ca-primary, #0e2e80);
  background: var(--ca-surface-hover, #f8faff);
  color: var(--ca-primary-dark, #0d2863);
}

.clear-search {
  align-self: stretch;
}

.table-region {
  min-width: 0;
  overflow-x: auto;
}

.table-region app-main-table {
  display: block;
  min-width: 0;
}

.inline-loading {
  display: flex;
  min-height: 4.5rem;
  align-items: center;
  gap: 0.65rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.9rem;
}

.inline-error {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin: 0.75rem 0;
  padding: 0.875rem 1rem;
  border: 1px solid var(--ca-danger, #dc3545);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-danger-bg, #fdecef);
  color: var(--ca-text-primary, #172033);
  font-size: 0.875rem;
}

.inline-retry {
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--ca-primary, #0e2e80);
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
}

.state-panel,
.no-results {
  display: flex;
  min-height: 15rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  padding: 2rem 1rem;
  color: var(--ca-text-tertiary, #6f7b91);
  text-align: center;
}

.state-panel > i,
.no-results > i {
  color: var(--ca-primary-light, #2850ad);
  font-size: 2rem;
}

.state-panel h2,
.no-results h3 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 1.15rem;
  font-weight: 700;
}

.state-panel p,
.no-results p {
  max-width: 35rem;
  margin: 0 0 0.5rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.9rem;
  line-height: 1.6;
}

.error-state > i {
  color: var(--ca-danger, #dc3545);
}

.loading-spinner {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  border: 3px solid var(--ca-border, #dfe4ec);
  border-top-color: var(--ca-primary, #0e2e80);
  border-radius: 50%;
  animation: data-asset-mapping-spin 0.8s linear infinite;
}

.loading-spinner-sm {
  width: 1.1rem;
  height: 1.1rem;
  border-width: 2px;
}

.loading-state p {
  margin: 0.8rem 0 0;
}

.list-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 1.25rem;
  padding-top: 1rem;
  border-top: 1px solid var(--ca-border-light, #e9edf3);
}

.pagination-summary {
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.78rem;
}

@keyframes data-asset-mapping-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 1100px) {
  .search-toolbar {
    grid-template-columns: minmax(0, 1fr) minmax(12rem, 0.8fr);
  }
  .clear-search {
    grid-column: 1/-1;
    justify-self: start;
  }
}
@media (max-width: 767.98px) {
  .breadcrumb {
    margin: 0.75rem 1rem 0;
  }
  .asset-mapping-page {
    padding: 1rem;
  }
  .page-header,
  .list-heading {
    align-items: flex-start;
    flex-direction: column;
  }
  .page-header-meta {
    min-width: 0;
  }
  .asset-list-card {
    padding: 0.875rem;
  }
  .search-toolbar {
    grid-template-columns: minmax(0, 1fr);
  }
  .clear-search {
    grid-column: auto;
    justify-self: start;
  }
  .list-footer {
    align-items: stretch;
    flex-direction: column;
  }
  .list-footer app-pagination {
    align-self: flex-end;
    max-width: 100%;
  }
}
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    scroll-behavior: auto !important;
    transition-duration: 0.01ms !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/data-protection/data-asset-mapping/data-asset-mapping.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;EACA,sCAAA;AACF;;AAEA;EACE,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;EACA,mBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,iCAAA;EACA,gBAAA;AACF;;AAEA;;EAEE,kBAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA;EACE,wCAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;;EAEE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,YAAA;EACA,sBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,mBAAA;EACA,sCAAA;EACA,sCAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AACF;;AAEA;;EAEE,SAAA;EACA,wCAAA;EACA,iBAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,iDAAA;EACA,uCAAA;EACA,mCAAA;EACA,gEAAA;AACF;;AAEA;EACE,aAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,uCAAA;EACA,6CAAA;EACA,iCAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,sCAAA;EACA,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE,uCAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,gBAAA;EACA,iDAAA;EACA,wCAAA;EACA,mCAAA;EACA,gEAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,sBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AACF;;AAEA;EACE,kBAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,6BAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,+CAAA;EACA,yCAAA;EACA,iCAAA;AACF;AACE;EACE,sCAAA;AACJ;;AAGA;EACE,qBAAA;EACA,wCAAA;EACA,gCAAA;AAAF;AAEE;EACE,qCAAA;AAAJ;;AAIA;EACE,aAAA;EACA,sEAAA;EACA,aAAA;EACA,sBAAA;AADF;;AAIA;EACE,aAAA;EACA,YAAA;EACA,oBAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iDAAA;EACA,uCAAA;EACA,0CAAA;EACA,sCAAA;EACA,iBAAA;AADF;AAGE;EACE,4CAAA;EACA,gDAAA;EACA,UAAA;AADJ;AAIE;EACE,oCAAA;AAFJ;;AAMA;EACE,0BAAA;EACA,6BAAA;AAHF;;AAMA;EACE,oBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,4CAAA;EACA,oEAAA;EACA,sCAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,uCAAA;AAHF;AAKE;EACE,2CAAA;AAHJ;AAME;EACE,kBAAA;EACA,UAAA;EACA,0CAAA;EACA,mBAAA;AAJJ;;AAQA;;EAEE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,uCAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uFAAA;AALF;AAOE;;EACE,0CAAA;EACA,mBAAA;EACA,gBAAA;AAJJ;AAOE;;EACE,mBAAA;EACA,YAAA;AAJJ;;AAQA;EACE,4CAAA;EACA,sCAAA;EACA,WAAA;AALF;AAOE;EACE,6CAAA;EACA,2CAAA;EACA,WAAA;AALJ;;AASA;EACE,2CAAA;EACA,mCAAA;EACA,iCAAA;AANF;AAQE;EACE,wCAAA;EACA,4CAAA;EACA,sCAAA;AANJ;;AAUA;EACE,mBAAA;AAPF;;AAUA;EACE,YAAA;EACA,gBAAA;AAPF;;AAUA;EACE,cAAA;EACA,YAAA;AAPF;;AAUA;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,wCAAA;EACA,iBAAA;AAPF;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,2CAAA;EACA,uCAAA;EACA,wCAAA;EACA,sCAAA;EACA,mBAAA;AAPF;;AAUA;EACE,UAAA;EACA,SAAA;EACA,uBAAA;EACA,iCAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;AAPF;;AAUA;;EAEE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,uCAAA;EACA,kBAAA;AAPF;;AAUA;;EAEE,uCAAA;EACA,eAAA;AAPF;;AAUA;;EAEE,SAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;AAPF;;AAUA;;EAEE,gBAAA;EACA,kBAAA;EACA,wCAAA;EACA,iBAAA;EACA,gBAAA;AAPF;;AAUA;EACE,gCAAA;AAPF;;AAUA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,4CAAA;EACA,kBAAA;EACA,uDAAA;AAPF;;AAUA;EACE,aAAA;EACA,cAAA;EACA,iBAAA;AAPF;;AAUA;EACE,kBAAA;AAPF;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,qDAAA;AAPF;;AAUA;EACE,uCAAA;EACA,kBAAA;AAPF;;AAUA;EACE;IAAK,yBAAA;EANL;AACF;AAQA;EACE;IACE,0DAAA;EANF;EASA;IACE,iBAAA;IACA,mBAAA;EAPF;AACF;AAUA;EACE;IACE,sBAAA;EARF;EAWA;IACE,aAAA;EATF;EAYA;;IAEE,uBAAA;IACA,sBAAA;EAVF;EAaA;IACE,YAAA;EAXF;EAcA;IACE,iBAAA;EAZF;EAeA;IACE,qCAAA;EAbF;EAgBA;IACE,iBAAA;IACA,mBAAA;EAdF;EAiBA;IACE,oBAAA;IACA,sBAAA;EAfF;EAkBA;IACE,oBAAA;IACA,eAAA;EAhBF;AACF;AAmBA;EACE;;;IAGE,qCAAA;IACA,uCAAA;IACA,gCAAA;IACA,sCAAA;EAjBF;AACF","sourcesContent":[":host {\n  display: block;\n  min-width: 0;\n  color: var(--ca-text-primary, #172033);\n}\n\n.breadcrumb {\n  margin-top: 1.5rem;\n  margin-left: 1.5rem;\n}\n\n.breadcrumb-nav {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0 0 1.25rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.875rem;\n}\n\n.breadcrumb-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  color: var(--ca-primary, #0e2e80);\n  font-weight: 500;\n}\n\n.breadcrumb-link i,\n.breadcrumb-current i {\n  font-size: 1.15rem;\n}\n\n.breadcrumb-separator {\n  color: var(--ca-text-muted, #8c96a8);\n}\n\n.breadcrumb-current {\n  color: var(--ca-text-secondary, #4b5870);\n  font-weight: 600;\n}\n\n.asset-mapping-page {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  padding: 1.5rem;\n  margin: 0 auto;\n}\n\n.page-header,\n.list-heading {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1.25rem;\n  margin-bottom: 1.25rem;\n}\n\n.page-heading {\n  min-width: 0;\n}\n\n.page-heading h1 {\n  margin: 0 0 0.35rem;\n  color: var(--ca-text-primary, #172033);\n  font-size: clamp(1.35rem, 2vw, 1.7rem);\n  font-weight: 650;\n  letter-spacing: -0.02em;\n  line-height: 1.3;\n}\n\n.page-heading p,\n.list-heading p {\n  margin: 0;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.9rem;\n  line-height: 1.55;\n}\n\n.page-header-meta {\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 0.75rem;\n  min-width: 9.5rem;\n  padding: 0.7rem 0.9rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-surface, #fff);\n  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));\n}\n\n.header-meta-icon {\n  display: grid;\n  width: 2.4rem;\n  height: 2.4rem;\n  flex: 0 0 2.4rem;\n  place-items: center;\n  border-radius: var(--ca-radius-sm, 6px);\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n  font-size: 1.1rem;\n}\n\n.page-header-meta > div {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.page-header-meta strong {\n  color: var(--ca-text-primary, #172033);\n  font-size: 1.1rem;\n  line-height: 1.2;\n}\n\n.page-header-meta span:not(.header-meta-icon) {\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.72rem;\n  white-space: nowrap;\n}\n\n.asset-list-card {\n  min-width: 0;\n  padding: 1.25rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-lg, 12px);\n  background: var(--ca-surface, #fff);\n  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));\n}\n\n.list-heading {\n  align-items: center;\n}\n\n.section-eyebrow {\n  margin-bottom: 0.35rem;\n  color: var(--ca-primary-light, #2850ad);\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n}\n\n.list-heading h2 {\n  margin: 0 0 0.3rem;\n  color: var(--ca-text-primary, #172033);\n  font-size: 1.15rem;\n  font-weight: 700;\n}\n\n.mapping-legend {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.6rem;\n}\n\n.legend-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.4rem 0.65rem;\n  border: 1px solid transparent;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 650;\n  white-space: nowrap;\n}\n\n.legend-dot {\n  width: 0.45rem;\n  height: 0.45rem;\n  border-radius: 50%;\n}\n\n.legend-mapped {\n  border-color: var(--ca-success-border, #b7e3ca);\n  background: var(--ca-success-bg, #eaf7f0);\n  color: var(--ca-success, #198754);\n\n  .legend-dot {\n    background: var(--ca-success, #198754);\n  }\n}\n\n.legend-unmapped {\n  border-color: #f3b9c0;\n  background: var(--ca-danger-bg, #fdecef);\n  color: var(--ca-danger, #dc3545);\n\n  .legend-dot {\n    background: var(--ca-danger, #dc3545);\n  }\n}\n\n.search-toolbar {\n  display: grid;\n  grid-template-columns: minmax(16rem, 1.5fr) minmax(13rem, 0.85fr) auto;\n  gap: 0.875rem;\n  margin-bottom: 1.25rem;\n}\n\n.search-field {\n  display: flex;\n  min-width: 0;\n  align-items: stretch;\n}\n\n.search-control {\n  width: 100%;\n  min-width: 0;\n  min-height: 2.65rem;\n  border: 1px solid var(--ca-input-border, #dfe4ec);\n  border-radius: var(--ca-radius-md, 8px);\n  background-color: var(--ca-input-bg, #fff);\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.9rem;\n\n  &:focus {\n    border-color: var(--ca-input-focus, #2850ad);\n    box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.15);\n    outline: 0;\n  }\n\n  &::placeholder {\n    color: var(--ca-text-muted, #8c96a8);\n  }\n}\n\n.search-field .search-control {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.search-submit {\n  display: inline-grid;\n  width: 2.8rem;\n  flex: 0 0 2.8rem;\n  place-items: center;\n  border: 1px solid var(--ca-primary, #0e2e80);\n  border-radius: 0 var(--ca-radius-md, 8px) var(--ca-radius-md, 8px) 0;\n  background: var(--ca-primary, #0e2e80);\n  color: #fff;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n\n  &:hover {\n    background: var(--ca-primary-dark, #0d2863);\n  }\n\n  &:focus-visible {\n    position: relative;\n    z-index: 1;\n    outline: 3px solid rgba(40, 80, 173, 0.25);\n    outline-offset: 2px;\n  }\n}\n\n.btn-primary,\n.btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  min-height: 2.6rem;\n  padding: 0.65rem 1rem;\n  border-radius: var(--ca-radius-md, 8px);\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1.25;\n  white-space: nowrap;\n  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;\n\n  &:focus-visible {\n    outline: 3px solid rgba(40, 80, 173, 0.25);\n    outline-offset: 2px;\n    box-shadow: none;\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.6;\n  }\n}\n\n.btn-primary {\n  border: 1px solid var(--ca-primary, #0e2e80);\n  background: var(--ca-primary, #0e2e80);\n  color: #fff;\n\n  &:hover:not(:disabled) {\n    border-color: var(--ca-primary-dark, #0d2863);\n    background: var(--ca-primary-dark, #0d2863);\n    color: #fff;\n  }\n}\n\n.btn-secondary {\n  border: 1px solid var(--ca-border, #dfe4ec);\n  background: var(--ca-surface, #fff);\n  color: var(--ca-primary, #0e2e80);\n\n  &:hover:not(:disabled) {\n    border-color: var(--ca-primary, #0e2e80);\n    background: var(--ca-surface-hover, #f8faff);\n    color: var(--ca-primary-dark, #0d2863);\n  }\n}\n\n.clear-search {\n  align-self: stretch;\n}\n\n.table-region {\n  min-width: 0;\n  overflow-x: auto;\n}\n\n.table-region app-main-table {\n  display: block;\n  min-width: 0;\n}\n\n.inline-loading {\n  display: flex;\n  min-height: 4.5rem;\n  align-items: center;\n  gap: 0.65rem;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.9rem;\n}\n\n.inline-error {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  margin: 0.75rem 0;\n  padding: 0.875rem 1rem;\n  border: 1px solid var(--ca-danger, #dc3545);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-danger-bg, #fdecef);\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.875rem;\n}\n\n.inline-retry {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--ca-primary, #0e2e80);\n  font-weight: 700;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.state-panel,\n.no-results {\n  display: flex;\n  min-height: 15rem;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.65rem;\n  padding: 2rem 1rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  text-align: center;\n}\n\n.state-panel > i,\n.no-results > i {\n  color: var(--ca-primary-light, #2850ad);\n  font-size: 2rem;\n}\n\n.state-panel h2,\n.no-results h3 {\n  margin: 0;\n  color: var(--ca-text-primary, #172033);\n  font-size: 1.15rem;\n  font-weight: 700;\n}\n\n.state-panel p,\n.no-results p {\n  max-width: 35rem;\n  margin: 0 0 0.5rem;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.9rem;\n  line-height: 1.6;\n}\n\n.error-state > i {\n  color: var(--ca-danger, #dc3545);\n}\n\n.loading-spinner {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  border: 3px solid var(--ca-border, #dfe4ec);\n  border-top-color: var(--ca-primary, #0e2e80);\n  border-radius: 50%;\n  animation: data-asset-mapping-spin 0.8s linear infinite;\n}\n\n.loading-spinner-sm {\n  width: 1.1rem;\n  height: 1.1rem;\n  border-width: 2px;\n}\n\n.loading-state p {\n  margin: 0.8rem 0 0;\n}\n\n.list-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-top: 1.25rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--ca-border-light, #e9edf3);\n}\n\n.pagination-summary {\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.78rem;\n}\n\n@keyframes data-asset-mapping-spin {\n  to { transform: rotate(360deg); }\n}\n\n@media (max-width: 1100px) {\n  .search-toolbar {\n    grid-template-columns: minmax(0, 1fr) minmax(12rem, 0.8fr);\n  }\n\n  .clear-search {\n    grid-column: 1 / -1;\n    justify-self: start;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .breadcrumb {\n    margin: 0.75rem 1rem 0;\n  }\n\n  .asset-mapping-page {\n    padding: 1rem;\n  }\n\n  .page-header,\n  .list-heading {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .page-header-meta {\n    min-width: 0;\n  }\n\n  .asset-list-card {\n    padding: 0.875rem;\n  }\n\n  .search-toolbar {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .clear-search {\n    grid-column: auto;\n    justify-self: start;\n  }\n\n  .list-footer {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .list-footer app-pagination {\n    align-self: flex-end;\n    max-width: 100%;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    scroll-behavior: auto !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
